import type { ZInfer, userSchemas } from 'types';
import { Api } from './fetch';

export class UserNet {
  static getMe = () => Api.get<'user', 'getMe'>('/user');
  static editMe = (body: ZInfer<typeof userSchemas.optionalUser>) => Api.patch<'user', 'editMe'>('/user', { body });
  static getDonations = () => Api.get<'user', 'getDonations'>('/user/donations');
  static getDonationReceipt = (id: string) =>
    Api.get<'user', 'getDonationReceipt'>('/user/donation/receipt', { query: { id } });
  static getProfileUploadURL = (mimeType: string) =>
    Api.get<'user', 'getProfileUploadURL'>('/user/image/profile/upload', { query: { mimeType } });
  static updateProfileImage = (key: string) =>
    Api.patch<'user', 'updateProfileImage'>('/user/image/profile', { body: { key } });
  static deleteProfileImage = () => Api.delete<'user', 'deleteProfileImage'>('/user/image/profile');
}
